// extracted by mini-css-extract-plugin
export default {"archived":"PlanCatalog_archived__qeOae","diffCell":"PlanCatalog_diffCell__+EXSJ"};